"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _actions = require("../../../../../actions");
var _reactJoyride = _interopRequireDefault(require("react-joyride"));
var _platform = require("../../../../../helpers/platform");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var WalkthroughTooltip = function WalkthroughTooltip(_ref) {
  var joyrideRef = _ref.joyrideRef,
    onboardingFavoriteAction = _ref.onboardingFavoriteAction,
    closeOnboardingFavoriteAction = _ref.closeOnboardingFavoriteAction,
    reloadChatList = _ref.reloadChatList;
  var steps = [{
    target: '#step1',
    content: 'Agora você pode favoritar mensagens ' + 'importantes clicando neste ícone!',
    disableBeacon: true,
    hideBackButton: true,
    hideFooter: true,
    placement: _platform.isMsite ? 'left' : 'right',
    spotlightPadding: 8,
    floaterProps: {
      styles: {
        arrow: {
          length: 8,
          spread: 18
        }
      }
    },
    event: 'click',
    styles: {
      options: {
        zIndex: 10000,
        width: '251px'
      },
      spotlight: {
        borderRadius: 'var(--border-radius-circle)'
      },
      tooltip: {
        borderRadius: 'var(--border-radius-sm)',
        padding: 'var(--spacing-2)'
      },
      tooltipContent: {
        padding: 0,
        textAlign: 'left'
      }
    }
  }];
  var handleStateChange = function handleStateChange(data) {
    if (data.lifecycle === 'ready') {
      onboardingFavoriteAction();
    }
    if (data.action === 'close') {
      window.localStorage.setItem('tourFavoriteChatClosed', 'true');
      closeOnboardingFavoriteAction();
      if (_platform.isMsite) {
        reloadChatList();
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactJoyride["default"], {
    ref: joyrideRef,
    steps: steps,
    run: true,
    continuous: false,
    callback: handleStateChange,
    styles: {
      options: {
        textColor: '#1a1d23',
        width: 263
      }
    }
  });
};
WalkthroughTooltip.propTypes = {
  joyrideRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].elementType
  })]).isRequired,
  onboardingFavoriteAction: _propTypes["default"].func.isRequired,
  closeOnboardingFavoriteAction: _propTypes["default"].func.isRequired,
  reloadChatList: _propTypes["default"].func.isRequired
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    onboardingFavoriteAction: _actions.onboardingFavorite,
    closeOnboardingFavoriteAction: _actions.closeOnboardingFavorite
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(null, mapDispatchToProps)(WalkthroughTooltip);